import React from "react";
import { motion } from "framer-motion";
import FlexContainer from "../../Container/FlexContainer";
import DropdownHeading from "../shared/DropdownHeading";
import PromoCard from "../shared/PromoCard";
import LinkList from "./LinkList";

const Container = ({ content }) => {
  return (
    <motion.span
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{
        opacity: 0,
        transition: {
          duration: 0.3,
          delay: 0,
          ease: "easeInOut"
        }
      }}
      transition={{
        duration: 0.3,
        delay: 0.2,
        ease: "easeInOut"
      }}
    >
      <DropdownHeading>{content.title}</DropdownHeading>
      <FlexContainer>
        <PromoCard
          heading={content.promoHeading}
          image={content.promoImage}
          link={content.promoLink}
          secondaryLink={content.secondaryPromoLink}
        />
        <div>
          {content.lists.map(list => (
            <LinkList list={list} />
          ))}
        </div>
      </FlexContainer>
    </motion.span>
  );
};

export default Container;
